export default __webpack_public_path__ + "static/media/FileUpload.a73f2296.svg";